var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header",attrs:{"data-agl-cvt":"6"},on:{"click":function($event){return _vm.$emit('download')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }